import { faCheckCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { capitalizeFirstLetter } from "@joonapp/web-shared"
import { JoonUIColor } from "@joonapp/web-shared"
import { UserRole } from "@joonapp/web-shared"
import { FamilyParentProfile } from "@joonapp/web-shared"
import { FamilyChildProfile } from "@joonapp/web-shared"
import { Typography } from "@joonapp/web-shared"
import { useId } from "react"
import { Tooltip } from "react-tooltip"

export const UserInitial = ({
  userProfile,
  isCompleted,
  showTooltip = true,
}: {
  userProfile: FamilyParentProfile | FamilyChildProfile
  isCompleted?: boolean
  showTooltip?: boolean
}) => {
  const isParent = userProfile.role === UserRole.PARENT
  const tooltipId = useId()

  return (
    <>
      {showTooltip && (
        <Tooltip id={tooltipId}>
          <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
            {userProfile.user.name}
          </Typography>
        </Tooltip>
      )}
      <div
        className={`flex flex-row gap-1 ${
          isParent ? "bg-yellow-200" : "bg-green-200"
        } min-w-6 min-h-6 max-w-6 max-h-6 rounded-full items-center justify-center relative`}
        data-tooltip-id={tooltipId}
      >
        {isCompleted && (
          <FontAwesomeIcon
            icon={faCheckCircle}
            color={JoonUIColor.semantic.success}
            fontSize="12px"
            className="absolute bottom-[-2px] right-[-3px]"
          />
        )}
        <Typography variant="bodySmall">
          {capitalizeFirstLetter(userProfile.user.name.slice(0, 2))}
        </Typography>
      </div>
    </>
  )
}
